"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function Plans(_a) {
    var params = _a.params, setCount = _a.setCount;
    var plans = ra_fetch_1.useApi('ecommerce').index('plans', params)[0];
    if (setCount) {
        react_1.useEffect(function () {
            setCount(plans.meta.total);
        }, [plans.meta]);
    }
    if (plans.loading || !plans.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-channels-plans' },
        react_1.default.createElement(storybook_1.Subscriptions.Cards, { plans: plans.data }));
}
exports.default = Plans;
